import { axiosWithAuth } from "../../plugins/axios";
import { getAPIUrlByRole } from "./config";

/**
 * Determines whether a user is allowed to access the Autograder tool.
 *
 * - Any @upgrad.com email is allowed automatically (no backend call).
 * - Any other email is checked against the backend `allow_access` collection.
 *   Access is granted only if the email exists there; otherwise it is denied.
 *
 * The backend call is fail-closed: on any error the user is denied access.
 */
export const checkAllowAccess = async (
  email: string,
  role: string
): Promise<boolean> => {
  const normalized = (email || "").toLowerCase().trim();
  if (!normalized) {
    return false;
  }
  if (normalized.endsWith("@upgrad.com")) {
    return true;
  }

  try {
    // Strip any trailing slash so we don't build a "//allowAccess" URL when
    // the configured base URL already ends with "/".
    const apiUrl = (getAPIUrlByRole(role) || "").replace(/\/+$/, "");
    const response = await axiosWithAuth(
      `${apiUrl}/allowAccess/check`,
      { params: { email: normalized } },
      "get"
    );
    return Boolean(response?.data?.allowed);
  } catch (error) {
    console.error("Access check failed:", error);
    return false;
  }
};
